/* Shopify GET filters: full-page navigation, no new API or client-side product data. */
(() => {
  'use strict';
  if (window.vnCollectionUX20260922) {
    window.vnCollectionUX20260922.start();
    return;
  }
  const controllers = new Map();
  const mobile = window.matchMedia('(max-width: 1000px)');
  const isFilter = name => name.startsWith('filter.');
  const isPage = name => name === 'page' || name.startsWith('page_');

  // Preserve search/campaign parameters; filters and sorting come from the GET form.
  function formURL(form, current = new URL(window.location.href)) {
    const destination = new URL(form.action, current);
    destination.search = '';
    current.searchParams.forEach((value, name) => {
      if (!isFilter(name) && name !== 'sort_by' && !isPage(name)) destination.searchParams.append(name, value);
    });
    const values = new FormData(form);
    const names = new Set([...values.keys()]);
    names.forEach(name => destination.searchParams.delete(name));
    values.forEach((value, name) => {
      if (typeof value === 'string' && value.trim() !== '' && !isPage(name)) destination.searchParams.append(name, value);
    });
    return destination;
  }

  function initialize(root) {
    if (controllers.has(root)) return;
    const dialog = root.querySelector('[data-vn-filters-dialog]');
    const trigger = root.querySelector('[data-vn-filters-open]');
    const toolbar = root.querySelector('[data-vn-collection-toolbar]');
    const panel = dialog?.querySelector('.vn-collection-filters__panel');
    if (!dialog || !trigger || !toolbar || !panel) return;
    const abort = new AbortController();
    const listen = (node, type, handler) => node.addEventListener(type, handler, { signal: abort.signal });
    const current = new URL(window.location.href);
    let opener = null;

    // Shopify's remove/pagination URLs remain authoritative for the filter values.
    function preserveContext(link, mode) {
      const url = new URL(link.href, current);
      new Set(current.searchParams.keys()).forEach(name => {
        if ((isFilter(name) && mode !== 'page') || isPage(name) || url.searchParams.has(name)) return;
        current.searchParams.getAll(name).forEach(value => url.searchParams.append(name, value));
      });
      if (mode !== 'page') [...url.searchParams.keys()].filter(isPage).forEach(name => url.searchParams.delete(name));
      if (mode === 'clear') [...url.searchParams.keys()].filter(isFilter).forEach(name => url.searchParams.delete(name));
      link.href = url.href;
    }
    root.querySelectorAll('[data-vn-clear-filters]').forEach(link => preserveContext(link, 'clear'));
    root.querySelectorAll('[data-vn-filter-remove]').forEach(link => preserveContext(link, 'remove'));
    root.querySelectorAll('[data-vn-filter-category]').forEach(link => preserveContext(link, 'category'));
    root.querySelectorAll('.vn-pag a').forEach(link => preserveContext(link, 'page'));

    root.querySelectorAll('[data-vn-collection-form]').forEach(form => {
      listen(form, 'submit', event => {
        event.preventDefault();
        window.location.assign(formURL(form).href);
      });
    });
    root.querySelectorAll('[data-vn-collection-sort-select]').forEach(select => {
      listen(select, 'change', () => select.form?.requestSubmit());
    });
    root.querySelectorAll('[data-vn-filter-price]').forEach(group => {
      const min = group.querySelector('[data-vn-price-min]');
      const max = group.querySelector('[data-vn-price-max]');
      const validate = () => {
        const reversed = min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
        max.setCustomValidity(reversed ? 'El precio máximo debe ser mayor o igual al mínimo.' : '');
      };
      listen(min, 'input', validate);
      listen(max, 'input', validate);
      listen(min.form, 'reset', () => queueMicrotask(validate));
      validate();
    });

    const isOpen = () => dialog.hasAttribute('open');
    function reflect() {
      trigger.setAttribute('aria-expanded', String(isOpen()));
      document.documentElement.classList.toggle('vn-collection-filters-open', !!document.querySelector('[data-vn-filters-dialog][open]'));
    }
    function close(restoreFocus = true) {
      if (!isOpen()) return;
      dialog.close();
      reflect();
      // Dismissal cancels edits; only Apply changes the current URL.
      dialog.querySelector('form')?.reset();
      dialog.querySelectorAll('[data-vn-filter-categories]').forEach(details => { details.open = false; });
      dialog.querySelectorAll('input').forEach(input => input.setCustomValidity(''));
      if (restoreFocus && opener?.isConnected && opener.getClientRects().length) opener.focus({ preventScroll: true });
    }
    function open() {
      if (!mobile.matches || isOpen()) return;
      opener = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
      dialog.showModal();
      reflect();
      panel.querySelector('[data-vn-filters-close]')?.focus({ preventScroll: true });
    }
    // Without native dialog support, keep the functional inline GET sidebar visible.
    if (typeof dialog.showModal === 'function') {
      root.classList.add('vn-collection-ux--enhanced');
      toolbar.hidden = false;
      listen(trigger, 'click', open);
      dialog.querySelectorAll('[data-vn-filters-close]').forEach(button => listen(button, 'click', () => close()));
      listen(dialog, 'click', event => {
        if (event.target === dialog) close();
        if (event.target instanceof Element && event.target.closest('a[href]')) close(false);
      });
      listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
      listen(dialog, 'close', reflect);
      listen(dialog, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); return; }
        if (event.key !== 'Tab') return;
        const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')]
          .filter(element => element.getClientRects().length && element.tabIndex !== -1);
        if (!focusable.length) { event.preventDefault(); return; }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      });
      listen(mobile, 'change', () => { if (!mobile.matches) close(false); });
    }
    controllers.set(root, { destroy() {
      close(false);
      abort.abort();
      root.classList.remove('vn-collection-ux--enhanced');
      toolbar.hidden = true;
      controllers.delete(root);
    } });
  }
  function start(scope = document) {
    if (scope instanceof Element && scope.matches('[data-vn-collection-ux]')) initialize(scope);
    scope.querySelectorAll('[data-vn-collection-ux]').forEach(initialize);
  }
  window.vnCollectionUX20260922 = { start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, root) => { if (root === event.target || event.target.contains(root)) controller.destroy(); });
  });
  window.addEventListener('pagehide', () => controllers.forEach(controller => controller.destroy()));
  window.addEventListener('pageshow', () => start());
})();
